import { ViewModel, View, ObservableArray } from "binder"
import { MachineEditorView } from "./machineEditor-view"
import { IMachine } from "../IMachine";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { MachineModel, MachineModelSelectorViewModel } from "../machineModelSelector-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class MachineEditorViewModel extends ViewModel implements IMachine, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
        this.machineModelSelector = new MachineModelSelectorViewModel(this);
        this.machineModelSelector.onSelectionChanged = x => this.onMachineModelChanged(x);

        this.serials = ObservableArray.create<Serial>();
        this.isCreate = true;
    }
    GetDefaultView(): View<ViewModel> {
        return new MachineEditorView();
    }
    public getTypeId(): string {
        return "VM-E1BAA92E-415D-4AB1-A582-197844D88EB1"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set serialId(v: string) { this._serialId = v; } public get serialId(): string { return this._serialId; } private _serialId: string;
    public set machineModelId(v: string) { this._machineModelId = v; } public get machineModelId(): string { return this._machineModelId; } private _machineModelId: string;
    public set machineModelSelector(v: MachineModelSelectorViewModel) { this._machineModelSelector = v; } public get machineModelSelector(): MachineModelSelectorViewModel { return this._machineModelSelector; } private _machineModelSelector: MachineModelSelectorViewModel;
    public set serial(v: string) { this._serial = v; } public get serial(): string { return this._serial; } private _serial: string;
    public set serials(v: ObservableArray<Serial>) { this._serials = v; } public get serials(): ObservableArray<Serial> { return this._serials; } private _serials: ObservableArray<Serial>;
    public set isCreate(v: boolean) { this._isCreate = v; } public get isCreate(): boolean { return this._isCreate; } private _isCreate: boolean;

    closePopup(result?: any) {

    }

    onMachineModelChanged(machine: MachineModel) {
        this.machineModelId = machine?.id;
    }
    setMachineModelId(id: string) {
        this.machineModelSelector.selectById(id);
    }
    getMachineModelId(): string {
        return this.machineModelSelector.selectedItem?.id;
    }

    setSerials(serials: string[]) {
        this.serials.update(...serials.map(item => {
            let serial = new Serial(this);
            serial.serial = item;
            return serial;
        }));
    }
    getSerials(): string[] {
        return this.serials.map(item => item.serial);
    }

    async cloneTo(machine: IMachine) {
        machine.id = this.id;
        machine.serialId = this.serial;
        machine.setMachineModelId(this.getMachineModelId());
        machine.setSerials(this.getSerials());
    }

    back() {
        this.closePopup(null);
    }

    async save(): Promise<void> {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت ماشین');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('ایرادی در مقادیر سریال برای این مدل ماشین وجود دارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('ماشین با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت ماشین', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getMachineModelId())) {
            result.push('مدل ماشین مشخص نشده است.');
        }
        if (this.isCreate == true) {
            if (this.serials.length == 0) {
                result.push('سریال ماشین مشخص نشده است.');
            }
        }
        else {
            if (stringIsNullOrEmpty(this.serialId)) {
                result.push('سریال ماشین مشخص نشده است.');
            }
        }
        return result;
    }

    addNewSerial(): void {
        let newSerial = new Serial(this);
        newSerial.serial = this.serialId;
        if (stringIsNullOrEmpty(newSerial.serial)) {
            this.messageBoxConfirmWarning('سریال ماشین مشخص نشده است.', 'خطا در افزودن');
        }
        else {
            this.serials.push(newSerial);
            this.serialId = null;
        }
    }

    removeSerial(serial: Serial) {
        this.serials.remove(serial);
    }
}

export interface IServerUpdater {
    execute(machine: IMachine): Promise<any>;
}

export class MachineInserter implements IServerUpdater {
    async execute(machine: IMachine): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolPlaceHolderServices/CreateMachine', {
                MachineModelId: machine.getMachineModelId(),
                SerialIds: machine.getSerials()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class MachineUpdater implements IServerUpdater {
    async execute(machine: IMachine): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ToolPlaceHolderServices/UpdateMachine', {
                MachineId: machine.id,
                MachineModelId: machine.getMachineModelId(),
                SerialId: machine.serialId
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class Serial extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: MachineEditorViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: MachineEditorViewModel;
    public set serial(v: string) { this._serial = v; } public get serial(): string { return this._serial; } private _serial: string;

    remove() {
        this._typedParent.removeSerial(this);
    }
}